<div [formGroup]="form">
  <p class="text">Checklist</p>
  <div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="makeAnalysis"
        labelPosition="before"
      >
        {{ Texts.makeAnalysis }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="bankSystemDB"
        labelPosition="before"
      >
        {{ Texts.bankSystemDB }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="locateTheCustomer"
        labelPosition="before"
      >
        {{ Texts.locateTheCustomer }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="validateCustomerClassification"
        labelPosition="before"
      >
        {{ Texts.validateCustomerClassification }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="customerActivity"
        labelPosition="before"
      >
        {{ Texts.customerActivity }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="otherAccounts"
        labelPosition="before"
      >
        {{ Texts.otherAccounts }}</mat-checkbox
      >
    </div>
    <div class="checkbox-tile">
      <mat-checkbox
        class="custom-checkbox"
        formControlName="analyzeAccounts"
        labelPosition="before"
      >
        {{ Texts.analyzeAccounts }}</mat-checkbox
      >
    </div>
    <div class="alert">
      <p>Calificar la alerta</p>
      <mat-radio-group aria-label="Select an option" formControlName="status">
        <div class="options">
          <mat-radio-button class="primary-radiobutton" value="normal"
            >Normal
          </mat-radio-button>
          <mat-radio-button class="primary-radiobutton" value="process"
            >En seguimiento
          </mat-radio-button>
          <mat-radio-button class="primary-radiobutton" value="potential"
            >Potencial de Reporte
          </mat-radio-button>
          <mat-radio-button class="primary-radiobutton" value="pending"
            >Pendiente
          </mat-radio-button>
        </div>
      </mat-radio-group>
    </div>
  </div>
</div>
